import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'

export const BORDER_WIDTH = 1
export const DATA_ROW_HEIGHT = 30

export const style = {
  root: {
    display: 'flex'
  },
  labelContainer: {
    flex: '0 0 auto',
    marginRight: 20
  },
  chartContainer: {
    flex: '1 1 auto'
  },
  labelText: {
    height: DATA_ROW_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  nullEffectLine: {
    stroke: colors.gray,
    strokeWidth: 1.5
  },
  svg: {
    display: 'block',
    overflow: 'visible'
  }
}

export const useStyles = createUseStyles(style)
